import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { getClientToDoList, viewClientData } from "store/services/clientService";
import MultiReportDownloadOptions from "pages/SideTabs/MyClients/Detail/component/TabContent/ToDoTab/Component/SubmittedData/Component/MultiReportDownload/Index";
import { setAxiosAccessToken } from "helpers/Http";
import { useShowLoader } from "hooks/useShowLoader";

const ExportData = ({ dispatch, completedTodoItems }) => {
  const { clientId } = useParams();

  const [isLoaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);

  const showLoader = useShowLoader();

  const client = {
    id: clientId,
    first_name: "Test",
    last_name: "Client",
  }

  useEffect(() => {
    if(!error) {
      return;
    }

    typeof window.backendProcessBlobs === "function" && window.backendProcessBlobs(error);
  }, [error]);

  useEffect(() => {
    if (typeof window.backendHeartbeat !== "function") return;
  
    const pingInternal = 25000; // 25 Seconds
    const intervalId = setInterval(() => {
      window.backendHeartbeat();
    }, pingInternal);
  
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    async function init() {
      try {
        if (!localStorage.getItem("access_token")) {
          const queryParams = new URLSearchParams(window.location.search);
          const accessToken = queryParams.get("access_token");
          if (!accessToken) {
            setError("Authentication error!");
            return;
          }
          setAxiosAccessToken(accessToken);
          // return;
        }
        showLoader(true);

        await Promise.all([
          getClientTodo(),
          fetchClientDetails(),
        ])
        showLoader(false);
        setLoaded(true);
      } catch (err) {
        console.log("Failed to initialize", err);
        showLoader(false);
        setLoaded(false);
        setError(err.message || "Failed to Initialize!");
      }
    }

    init();
  }, []);

  const fetchClientDetails = async () => {
    try {
      let data = {
        clientId,
      };
      await dispatch(viewClientData(data));
    } catch (err) {
      console.log("Failed to fetch client details", err);
      throw err;
    }
  }

  // get currently editing todo list
  const getClientTodo = async () => {
    try {
      let data = {
        clientId,
      };
      await dispatch(getClientToDoList(data));
    } catch (err) {
      console.log("Error fetching todo list", err);
      throw err;
    }
  };

  return (
    <Container>
      <Row>
        <Col lg="12">
          {error ? (
            <p>{error}</p>
          ) : isLoaded ? (
            <MultiReportDownloadOptions
              completedToDos={completedTodoItems}
              client={client}
            />
          ) : (
            <p>Loading...</p>
          )}
        </Col>
      </Row>
    </Container>
  )
}

const mapStateToPros = (state) => {
  return {
    isLoading: state.persistStore.loader,
    completedTodoItems: state.Client.client.todoItems.todo_completed,
  };
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(ExportData);